<template>
  <div>
    <div class="preview-div">
      <el-image style="width: 600px;height: 600px" :src="curDisplayImageUrl" fit="contain"></el-image>
    </div>
    <div style="text-align: center;padding-top: 20px">
      <el-button icon="el-icon-caret-left" size="mini" @click="preBtnClick" style="margin-right: 20px"></el-button>
      <span>{{this.curPageIndex + '/' + this.curFileTotalCount}}</span>
      <el-button icon="el-icon-caret-right" size="mini" @click="nextBtnClick" style="margin-left: 20px"></el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CloudDiskImagePreview',
  data () {
    return {
      curDisplayImageUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      curBKFileUrl: '',
      curFileTotalCount: 1,
      curPageIndex: 1
    }
  },
  methods: {
    setLoadFile (bkfileUrl, totalCount) {
      this.curBKFileUrl = bkfileUrl
      this.curFileTotalCount = totalCount
      this.curPageIndex = 1
      this.getCurBKFile()
    },
    preBtnClick () {
      if (this.curPageIndex > 1) {
        this.curPageIndex --
        this.getCurBKFile()
      }
    },
    nextBtnClick () {
      if (this.curPageIndex < this.curFileTotalCount) {
        this.curPageIndex ++
        this.getCurBKFile()
      }
    },
    getCurBKFile () {
      let pageId = this.intTo4Str(this.curPageIndex)
      this.curDisplayImageUrl = this.curBKFileUrl.replace('xxxx', pageId)
    },
    intTo4Str (index) {
      if (index <= 9) {
        return '000' + index
      } else if (index <= 99) {
        return '00' + index
      } else if (index <= 999) {
        return '0' + index
      }
    }
  }
}
</script>

<style scoped>
  .preview-div{
    display:flex;
    align-items:center;
    justify-content:center;
  }
</style>



// WEBPACK FOOTER //
// src/components/cloudDisk/CloudDiskImagePreview.vue